<template>
  <v-toolbar style="background: #eee" absolute flat app class="my-0">
    <v-toolbar-side-icon class="hidden-lg-and-up tertiary--text" @click="toggleMenu" />

    <div v-if="isPartner()" class="font-weight-medium subheading mr-2">
      <v-icon>mdi-folder-account</v-icon>
      {{ name }}
    </div>

    <div v-if="isPartner()">
      <span v-if="count === 1">
        <v-icon>mdi-bank</v-icon>
        {{ places[0].name }}
      </span>

      <span v-else>
        <v-select
          style="padding-top: 0px"
          hide-details
          v-model="placeId"
          prepend-icon="mdi-bank"
          item-text="name"
          item-value="id"
          :items="places"
          @change="savePlaceId"
        />
      </span>
    </div>

    <v-spacer />

    <v-toolbar-items class="hidden-sm-and-down">
      <v-form v-if="isPartner()" @submit.prevent="submitCardNumber">
        <v-layout row wrap>
          <v-flex>
            <v-text-field name="name" label="Numer karty" id="id" @change="setCardNumber" />
          </v-flex>

          <v-flex align-self-center>
            <v-btn type="submit" flat color="black">Wyszukaj</v-btn>
          </v-flex>
        </v-layout>
      </v-form>

      <material-dialog
        title="Potwierdź wylogowanie"
        text="Czy na pewno chcesz się wylogować?"
        :show="showLogoutConfirmDialog"
        @close="toggleLogoutConfirm"
        @confirm="logout"
      />

      <v-btn aria-label="Wyloguj się" icon flat @click="toggleLogoutConfirm">
        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>
    </v-toolbar-items>

    <card-use-modal
      v-if="isPartner()"
      :show="cardUseModalMixin.cardUseModal"
      :cardnumber="cardUseModalMixin.cardNumber"
      @close="hideModal"
    />
  </v-toolbar>
</template>
<script>
import { isPartner, SessionStorage } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import MaterialDialog from '@/components/material/Dialog';
import { eventBus } from '@/main';
import { cardReaderMixin } from '@/mixins/cardReader';
import { cardUseModalMixin } from '@/mixins/cardUseModal';
import CardUseModal from '@/views/cardUsage/modal.vue';

// @vuese
// Header strony z nagłówkiem i ikonami do niektórych widoków
// @group MainLayout
export default {
  components: { CardUseModal, MaterialDialog },
  mixins: [cardReaderMixin, cardUseModalMixin],
  data() {
    return { title: undefined, placeId: undefined, showLogoutConfirmDialog: false };
  },
  methods: {
    // @vuese
    // Pokazywanie/Ukrywanie potwierdzenia wylogowania
    toggleLogoutConfirm() {
      this.showLogoutConfirmDialog = !this.showLogoutConfirmDialog;
    },
    // @vuese
    // Pokazywanie / ukrywanie menu bocznego (tylko na mniejszych ekranach)
    toggleMenu() {
      // Pokazuje / ukrywa menu boczne
      eventBus.$emit('toggleMenu');
    },
    // @vuese
    // Metoda do wylogowywania użytkownika
    // Czyści session storage
    logout() {
      this.$store.commit('auth/unauthorize');
      this.$store.commit('access/reset');
      this.$router.push({ name: 'login' });
    },
    // @vuese
    // Ustawia wybrany wcześniej  obiekt
    setPlaceId() {
      this.placeId = parseInt(localStorage.getItem(SessionStorage.PLACE_ID));
    },
    // @vuese
    // Zapisuje Id wybranego obiektu
    savePlaceId() {
      localStorage.setItem(SessionStorage.PLACE_ID, '' + this.placeId);
    },
    // @vuese
    // Sprawdza czy użytkownik jest partnerem
    isPartner
  },
  computed: {
    ...mapState({
      name: state => state.partners.data.name,
      places: state => state.partners.places.list,
      count: state => state.partners.places.count,
      breadcrumbList: state => state.breadcrumbs.breadcrumbs
    })
  },
  watch: {
    $route(val) {
      this.title = val.meta.toolbarTitle;
    }
  },
  mounted() {
    this.title = this.$route.meta.toolbarTitle;
    this.setPlaceId();
  }
};
</script>
